import { del, get, post, put } from '../utils/axios'

export const getWorksAPI = async (body) => {
  return await get('works', body)
}

export const getWorksHaveAPI = async (param) => {
  return await get('works/get/have/status', param)
}

export const createWorksAPI = async (body) => {
  return await post('works', body)
}

export const createWorksGroupAPI = async (body) => {
  return await post('works/groups', body)
}

export const updateFileWorksAPI = async (body) => {
  return await post('works/file', body)
}

export const updateWorksAPI = async (param, body) => {
  return await put('works', param, body)
}

export const deleteWorksAPI = async (param) => {
  return await del('works', param)
}
